angular.module('bizmetryApp').service('TemplateInstanceService', ['$http', 'CONFIG', function ($http, CONFIG) {

    function getAccountId() {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user?.id;
    }

    this.getAllMasterTemplates = function () {
        return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/master-templates');
    }

    // Obtener un template instance por ID
    this.getTemplateInstanceById = function (templateId) {
        return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/template-instance/' + templateId);
    };

    // Actualizar un template instance
    this.updateTemplateInstance = function (id, payload) {
        console.log('SERVICE - objeto recibido:', JSON.stringify(payload, null, 2));
        var url = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/template-instance/' + id;
        return $http.put(url, payload);
    };

    // ── API collection versions associated with a template version ──────────
    // Biz events targeting the template consume only these; the template can be
    // PUBLISHED only once they're all PUBLISHED (can_publish / publish_blockers).
    var apiCollectionsUrl = function (id) {
        return CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry/template-instance/' + id + '/api-collections';
    };

    // → { template_instance_id, editable, api_collections: [...], can_publish, publish_blockers }
    this.getApiCollections = function (id, options) {
        return $http.get(apiCollectionsUrl(id), { bmSkipLoader: !!(options && options.skipLoader) });
    };

    // replace: swap the version of the same collection already associated
    this.addApiCollection = function (id, collectionId, replace) {
        return $http.post(apiCollectionsUrl(id), { collection_id: collectionId, replace: !!replace });
    };

    this.removeApiCollection = function (id, collectionId) {
        return $http.delete(apiCollectionsUrl(id) + '/' + collectionId);
    };

    // 🗑️ DELETE: Eliminar un template instance
    this.deleteTemplateInstance = function (templateId, opts) {
        opts = opts || {};

        // Validación básica
        if (!templateId) {
            console.error('❌ [DELETE TEMPLATE] Missing templateId');
            return Promise.reject(new Error('Missing templateId'));
        }

        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance/${templateId}`;

        console.log('🗑️ [DELETE TEMPLATE] Deleting template instance');
        console.log('   Template ID:', templateId);
        console.log('   URL:', url);

        // Si querés pasar params o headers en opts:
        // opts.params  -> query params
        // opts.headers -> headers extra
        const config = {
            params: opts.params || undefined,
            headers: opts.headers || undefined
        };

        return $http.delete(url, config)
            .then(function (response) {
                console.log('✅ [DELETE TEMPLATE] Success:', response.status, response.data);
                return response;
            })
            .catch(function (error) {
                console.error('❌ [DELETE TEMPLATE] Error:', {
                    status: error.status,
                    data: error.data,
                    url: url
                });
                throw error;
            });
    };

    // ✅ PATCH: Actualizar campos específicos de un template instance (isDefaultTemplate, templateStatus)
    this.patchTemplateInstance = function (templateId, patchData) {
        console.log('🔧 [PATCH TEMPLATE] Patching template instance');
        console.log('   Template ID:', templateId);
        console.log('   Patch Data:', JSON.stringify(patchData, null, 2));

        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance/${templateId}`;

        return $http.patch(url, patchData)
            .then(function (response) {
                console.log('✅ [PATCH TEMPLATE] Success:', response.data);
                return response;
            })
            .catch(function (error) {
                console.error('❌ [PATCH TEMPLATE] Error:', error);
                throw error;
            });
    };

    // ✅ Importar resource_types en un template instance
    this.importResourceTypes = function (templateId, payload) {
        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance/${templateId}/resource_types/import`;
        return $http.post(url, payload);
    };

    // ✅ Orquestar actualización de Primary Keys en recursos cuando se actualiza un template
    this.orchestrateTemplateUpdatePKs = function (oldTemplate, newTemplate, profileId) {
        console.log('🔄 [ORCHESTRATE PK UPDATE] Initiating PK orchestration');
        console.log('   Old Template ID:', oldTemplate.id);
        console.log('   New Template ID:', newTemplate.id);
        console.log('   Profile ID:', profileId);

        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/orchestrator/templates/update-pks`;

        const payload = {
            oldTemplate: oldTemplate,
            newTemplate: newTemplate,
            profileId: profileId
        };

        console.log('📦 [ORCHESTRATE PK UPDATE] Payload:', JSON.stringify(payload, null, 2));

        return $http.post(url, payload)
            .then(function (response) {
                console.log('✅ [ORCHESTRATE PK UPDATE] Success:', response.data);
                return response;
            })
            .catch(function (error) {
                console.error('❌ [ORCHESTRATE PK UPDATE] Error:', error);
                throw error;
            });
    };

    // ✅ GET: Comparar dos template instances (diff)
    this.diffTemplateInstances = function (childId, parentId) {
        console.log('🔍 [DIFF TEMPLATE] Computing diff');
        console.log('   Child ID:', childId);
        console.log('   Parent ID:', parentId);

        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance/${childId}/diff/${parentId}`;

        return $http.get(url)
            .then(function (response) {
                console.log('✅ [DIFF TEMPLATE] Success:', response.data);
                return response;
            })
            .catch(function (error) {
                console.error('❌ [DIFF TEMPLATE] Error:', {
                    status: error.status,
                    data:   error.data,
                    url:    url
                });
                throw error;
            });
    };

    // 🗑️ DELETE CASCADE: Eliminar un template padre y todos sus descendientes
    this.deleteTemplateInstanceCascade = function (templateId) {

        if (!templateId) {
            console.error('❌ [DELETE CASCADE] Missing templateId');
            return Promise.reject(new Error('Missing templateId'));
        }

        const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry/template-instance/${templateId}/cascade`;

        console.log('🗑️ [DELETE CASCADE] Deleting template instance and descendants');
        console.log('   Parent Template ID:', templateId);
        console.log('   URL:', url);

        return $http.delete(url)
            .then(function (response) {
                console.log('✅ [DELETE CASCADE] Success:', response.status, response.data);
                return response;
            })
            .catch(function (error) {
                console.error('❌ [DELETE CASCADE] Error:', {
                    status: error.status,
                    data:   error.data,
                    url:    url
                });
                throw error;
            });
    };
    

}]);